export const REDUCER_NAME = 'ClientEdit'
export const MODAL_NAME = 'EditClientModal'

export const actions = {
  INITIALIZE: 'client-edit/INITIALIZE',
  INITIALIZE_COMPLETE: 'client-edit/INITIALIZE_COMPLETE',

  FETCH_SUCCESS: 'client-edit/FETCH_SUCCESS',
  FETCH_FAILURE: 'client-edit/FETCH_FAILURE',

  RESET: 'client-edit/RESET',
}
